module.exports = __webpack_public_path__ + "static/media/survey.d37a576b.svg";